export default __webpack_public_path__ + "static/media/stamp_2x.1ade9522.gif";